import axiosInstance from "./service-instance";
import { createUrl } from "utilities";
import { CONTENT_TYPES } from "constants";

class StageServiceGenerator {
    getStageList = stageIds =>
        axiosInstance.get(createUrl(["workflow", "stage-list"]), {
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            },
            params: {
                stage_ids: JSON.stringify(stageIds)
            }
        });
    getStages = (current_stage_id, action, case_id) =>
        axiosInstance.get("/case/movement/user-list/", {
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            },
            params: {
                stage_id: current_stage_id,
                type: action,
                case_id
            }
        });
    getStageUsers = (stage_id, action, case_id) =>
        axiosInstance.get("/case/movement/user-list/", {
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            },
            params: {
                stage_id,
                type: action,
                case_id
            }
        });
}

export default new StageServiceGenerator();
